import { defineStore } from 'pinia'
import { IMember, ISession } from '@/api/members/types'

/**
 * Session Store 儲存了目前會員登入狀態，使瀏覽器視窗同步
 */
export const useSessionStore = defineStore('session', () => {
  const member = useState<IMember | null>('currentMember', () => null)
  const authorization = useAuthorization()
  const session = useState<ISession | null>('currentSession', () => null)
  // openedTabs 留作未來 auto-logout 機制使用；目前 plugins/auto-logout.ts 已註解，跨分頁同步暫不啟用
  const openedTabs = ref(0)

  function setMember(value: IMember | null) {
    member.value = value
  }

  function setAuthorization(value: string | null) {
    authorization.value = value
  }

  function setSession(value: ISession | null) {
    session.value = value
  }

  function hookMounted(){
    openedTabs.value++
    if(process.client && window){
      window.addEventListener('beforeunload', (event) => {
        return hookUnmounted()
      }, { capture: true })
    }
  }

  function hookUnmounted(){
    openedTabs.value--
    if(openedTabs.value <= 0 && member.value){
      useLogout()
      return false
    }
  }

  return {
    member,
    session,
    authorization,
    openedTabs,
    setMember,
    setAuthorization,
    setSession,
    hookMounted,
    hookUnmounted,
  }
}, {
  // 關閉 pinia-shared-state：member/authorization/session 是登入狀態核心，
  // 一旦透過 BroadcastChannel 跨分頁同步，另一個 tab 的 stale state 可能在登出後 echo 回來把 currentMember 補回去（auth cookie 已清但 member ref 被覆蓋）
  share: { enable: false },
})
